import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';

import PictureComp from '@/components/picture/PictureComp.vue';

import { AuthorFragment } from '@/features/editorial/graphql/fragments/Author.fragment';

import { formatArticleDate } from '@/features/editorial/helpers/editorial-helper';

import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorInfo',
  props: {
    author: null,
    articleUpdatedAt: null,
    articlePublishedAt: null
  },
  emits: ["authorClicked"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'authorClicked', id: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	author: AuthorFragment | undefined;
	articleUpdatedAt: Date | string | undefined;
	articlePublishedAt: Date | string | undefined;
};

const { language, country } = storeToRefs(useLanguageStore());





return { __sfc: true,language, country, props, emits, PictureComp, formatArticleDate }
}

})